import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=0460d52e"
import script from "./Warehouses.vue?vue&type=script&lang=js"
export * from "./Warehouses.vue?vue&type=script&lang=js"
import style0 from "./Warehouses.vue?vue&type=style&index=0&id=0460d52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports